import { Image } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { getConfig } from 'src/utilities/config';
import { isSeamlessRoute } from 'src/utilities/route-utils';

export type LogoImageProps = React.ComponentProps<typeof Image>;

export default function LogoImage(props: LogoImageProps): JSX.Element {
  const { grubhubLogo, seamlessLogo } = getConfig();
  const isSeamless = isSeamlessRoute();

  const src = isSeamless ? seamlessLogo : grubhubLogo;
  const alt = isSeamless ? 'Seamless logo' : 'Grubhub logo';

  return <Image src={src} alt={alt} {...props} />;
}
